import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { searchMyContactsBackend } from './search-my-contacts.backend';
import { searchMyContactsReducer } from './search-my-contacts.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('searchMyContacts', searchMyContactsReducer),
    BackendModule.forFeature('searchMyContacts', searchMyContactsBackend),
  ],
})
export class DatastoreSearchMyContactsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-contacts/search-my-contacts.module.ts